export default (t) => [
  {
    text: t('Inventory'),
    value: 'name',
    sortable: false,
    width: 180
  },
  {
    text: t('Lot no.'),
    value: 'lot_number',
    sortable: false,
    width: 100
  },
  {
    text: t('Adjustment Quantity') + ' (+/-)',
    value: 'quantity',
    sortable: false,
    width: 140
  },
  {
    text: '',
    value: 'unit',
    sortable: false,
    width: 30
  },
  {
    text: t('_Adjustment.Optional'),
    value: 'reason_detail',
    sortable: false,
    width: 100
  }
];
